import AsyncStorage from '@react-native-async-storage/async-storage';
import { createSlice } from '@reduxjs/toolkit';

export interface ResetState {}

const initialState: ResetState = {};

const resetSlice = createSlice({
  name: 'reset',
  initialState,
  reducers: {
    resetRequest(state, action) {},
    resetSuccess(state, action) {
      // AsyncStorage.clear()
    },
    resetFailure(state, action) {},
  },
});

export const { resetRequest, resetSuccess, resetFailure } = resetSlice.actions;

export default resetSlice.reducer;
